import { useNavigate, useParams } from 'react-router-dom';
import { useCallback } from 'react';

export function useLanguageNavigate() {
  const navigate = useNavigate();
  const { lang } = useParams();

  const navigateWithLang = useCallback((to, options) => {
    if (typeof to === 'string' && to.startsWith('/') && lang) {
      navigate(`/${lang}${to}`, options);
    } else {
      navigate(to, options);
    }
  }, [navigate, lang]);

  return navigateWithLang;
}
